<template>
    <UserWrapper :extraWidth="false">
            <div class="contact-detail">
                <div class="desktop-view">
                    <Loader v-if="loading" />
                    
                    <!-- Empty message when no contacts -->
                    <div v-if="showEmptyMessage && !loading" class="empty-message">
                        <p>企業からメッセージが届くとここに表示されます。</p>
                    </div>
                    
                    <!-- Contact cards list only shown when there are contacts -->
                    <div v-if="!showEmptyMessage && !loading" class="contact-list-container">
                        <ContactList v-for="contact in contacts" :key="contact._id" :contact="contact" :profile="profile"/>
                    </div>
                    
                    <!-- Pagination only shown when there are contacts and multiple pages -->
                    <div class="pagination-area" v-if="totalPages > 1 && !showEmptyMessage">
                        <Pagination :total-page="totalPages" :callback="changePage" />
                    </div>
                </div>
            </div>
        <template v-slot:footer>
            <Footer/>
        </template>
    </UserWrapper>
</template>

<script>
import Api from '@/config/api';
import moment from 'moment';
// import ProfileHeader from "@/components/header.vue";
import UserWrapper from '../UserWrapper.vue';
import Pagination from '../Pagination.vue';
import Loader from '../Loader.vue';
import Footer from '../Footer.vue';
import ContactList from './ContactList.vue';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
export default {
    name: 'TopContacts',
    components: { UserWrapper, Pagination, Loader, Footer, ContactList },
    data(){
        return {
            loading: false,
            // contacts: [],
        }
    },
    computed: {
        ...mapGetters({ 
            contacts:'getContacts', 
            totalContacts: 'getTotalContacts',
            profile: 'getProfile'
        }),
        ...mapState({
            page: ({ contact }) => contact.currentPage,
        }),
        allContactsCount() {
            return this.contacts.length;
        },
        totalPages(){
            return this.totalContacts ? Math.ceil(this.totalContacts/20) : 0;
        },
        showEmptyMessage() {
            console.log(this.contacts.length)
            return this.contacts.length === 0;
        },
    },
    methods: {
        ...mapActions(['loadContacts', 'setProfile']),
        ...mapMutations(['setPage']),
        changePage(page){
            this.setPage(page);
        },
        async loadTopContacts(){
            try {
                const token = await this.$auth.getToken();
                const headers = {
                    Authorization: `Bearer ${token}`,
                };
                // console.log(Api.endpoints);
                const contacts = await this.axios({
                    method: 'get',
                    url: Api.url(`${Api.endpoints.allMessages}?page=${page}`),
                    headers: headers,
                });
                // console.log(contacts);
                this.contacts = contacts.data.data;
            } catch (err) {
                console.log(err);
            }
        }
    },
    async created(){
        this.loading = true;
        await this.setProfile();
        this.setPage(1);
        await this.loadContacts(1);
        this.loading = false;
    },
    watch: {
        page: function(currentPage) {
            this.loadContacts(currentPage);
        }
    }
}
</script>

<style scoped>
.contact-detail {
    width: 100%;
}

.contact-list-container {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.empty-message {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 47px;
    padding: 28px 20px;
    margin: 20px auto 0;
    border-radius: 10px;
    color: #787878;
    font-size: 16px;
    text-align: center;
    max-width: 887px;
    background: #ffffff;
}

.empty-message p {
    margin: 0;
}

@media (max-width: 768px) {
    .empty-message {
        margin: 110px auto 0;
        max-width: 346px;
        padding: 28px 20px;
    }
    
    .empty-message p {
        font-size: 12px;
    }
}

.pagination-area {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

@media(max-width: 550px) {
    .contact-detail {
        padding: 0px !important;
    }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* CSS rules for iPads in portrait mode */
  .contact-detail {
    padding: 0px;
  }
}

</style>